/**
 * Created by zixiong on 2019/3/21.
 */
import React, {Component} from 'react'
import {
    Form, Icon, Input, InputNumber, Button, Checkbox, Select
} from 'antd';
import "./style.less"
import Cookies from 'js-cookie';
import { openBusinessCheck, openBusiness } from "@/api/agent"

const { Option, OptGroup } = Select;

class OpenBusiness extends Component {
    constructor(props) {
        super(props);
        this.state = {
            packageType: "SITE_EXCLUSIVE_YEAR",
            siteId: "",
            appId: "",
            phoneNo: "",
            shopId: "",
            submitLoading: false,
            submitText: "开通套餐"
        }
    }

    openBusinessCall = (packageType, phoneNo, siteId, appId, shopId) => {
        openBusiness(packageType, phoneNo, siteId, appId, shopId)
            .then(data => {
                this.setState({
                    submitLoading: false,
                    submitText: "继续开通"
                });
                data ? alert("开通成功") : alert("开通失败，为了防止重复开通，请检查客户消费记录")
            });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.setState({
            submitLoading: true,
            submitText: "正在开通"
        });
        openBusinessCheck(this.state.packageType, this.state.phoneNo, this.state.siteId, this.state.appId, this.state.shopId)
            .then(data => {
                // 校验成功，继续开通
                console.log(data);
                if (data.code === 200) {
                    // 弹窗确认
                    const result = window.confirm(data.data.msg);
                    if (result) {
                        console.log("继续开通");
                        this.openBusinessCall(this.state.packageType, this.state.phoneNo, this.state.siteId, this.state.appId, this.state.shopId);
                    } else {
                        this.setState({
                            submitLoading: false,
                            submitText: "继续开通"
                        });
                    }
                }
                // 校验失败，弹窗
                else {
                    console.log(data);
                    alert(data.msg);
                    this.setState({
                        submitLoading: false,
                        submitText: "继续开通"
                    });
                }
            }).catch(err => {
                alert(err);
        })
    };

    render() {
        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 14 },
        };
        return (
            <React.Fragment>
                <div className="open-business-form">
                    {
                        // 模拟登陆不让进入购买
                        Cookies.get("IS_SIMULATE") ? <div style={{marginTop: "200px"}}>没有权限进入该页面</div>:
                        <Form onSubmit={this.handleSubmit} className="login-form" layout="horizontal" >
                            <Form.Item label="套餐类型" labelAlign="left">
                                <Select
                                    defaultValue={this.state.packageType}
                                    style={{ width: 200 }}
                                    onChange={value => this.setState({packageType: value})}
                                >
                                    <OptGroup label="站点套餐">
                                        <Option value="SITE_EXCLUSIVE_YEAR">站点尊享版包年</Option>
                                        <Option value="SITE_ADVANCED_YEAR">站点高级版包年</Option>
                                        <Option value="SITE_EXCLUSIVE_LIFETIME">站点钻石版</Option>
                                    </OptGroup>
                                    <OptGroup label="投票套餐">
                                        <Option value="VOTE_DIAMOND_ONE_YEAR">投票钻石版包年</Option>
                                        <Option value="VOTE_PLATINUM_ONE_YEAR">投票白金版包年</Option>
                                    </OptGroup>
                                    <OptGroup label="小程序套餐">
                                        <Option value="APP_ADVANCED_YEAR">小程序高级版包年</Option>
                                        <Option value="APP_ADVANCED_LIFETIME">小程序钻石版</Option>
                                    </OptGroup>
                                    <OptGroup label="快客多套餐">
                                        <Option value="IDK_PROFESSIONAL_YEAR">快客多专业版包年</Option>
                                    </OptGroup>
                                    <OptGroup label="其他">
                                        <Option value="SITE_EXCLUSIVE_AND_APP">站点+小程序套餐</Option>
                                    </OptGroup>
                                </Select>
                            </Form.Item>
                            {
                                ["SITE_ADVANCED_YEAR", "SITE_EXCLUSIVE_YEAR", "SITE_EXCLUSIVE_LIFETIME", "SITE_EXCLUSIVE_AND_APP"].includes(this.state.packageType) &&
                                <Form.Item label="站点id">
                                    <Input placeholder="请输入siteId" onChange={e => this.setState({siteId: e.target.value})} />
                                </Form.Item>
                            }
                            {
                                ["VOTE_DIAMOND_ONE_YEAR", "VOTE_PLATINUM_ONE_YEAR"].includes(this.state.packageType) &&
                                <Form.Item label="用户手机号">
                                    <Input placeholder="请输入用户手机号" onChange={e => this.setState({phoneNo: e.target.value})} />
                                </Form.Item>
                            }
                            {
                                ["APP_ADVANCED_YEAR", "APP_ADVANCED_LIFETIME", "SITE_EXCLUSIVE_AND_APP"].includes(this.state.packageType) &&
                                <Form.Item label="小程序id">
                                    <Input placeholder="请输入小程序appid" onChange={e => this.setState({appId: e.target.value})} />
                                </Form.Item>
                            }
                            {
                                ["IDK_PROFESSIONAL_YEAR"].includes(this.state.packageType) &&
                                <Form.Item label="快客多店铺id">
                                    <Input placeholder="请输入快客多店铺id" onChange={e => this.setState({shopId: e.target.value})} />
                                </Form.Item>
                            }
                            <Form.Item>
                                <Button type="primary" loading={this.state.submitLoading} htmlType="submit" className="login-form-button">
                                    { this.state.submitText }
                                </Button>

                            </Form.Item>
                        </Form>
                    }
                </div>
            </React.Fragment>
        );
    }
}

// const OpenBusiness = Form.create({ name: 'OpenBusinessForm'})(OpenBusinessForm);

export default OpenBusiness;

